import { errorHandler } from 'pobble-components/dist/error-handler'
import {
  apiDeleteMedia,
  apiCreateMedium,
  apiDeleteWork,
  apiRotateMedium,
  apiGetWork,
  apiUpdateWork,
  apiReorderMedia
} from '../../common/api/work'

export const fetchWorkUploadData = id => ({
  requestPrefix: 'WORK_UPLOAD:FETCH',
  request: () =>
    apiGetWork(id, {
      include:
        'work.media,work.medium,work.medium.image,work.medium.details,work.student_type.account.names,work.student_type.policy'
    })
})

export const deleteMedia = id => ({
  requestPrefix: 'WORK_UPLOAD:DELETE_MEDIA',
  params: { id },
  request: () => apiDeleteMedia(id)
})

export const addMedia = (workId, data) => ({
  requestPrefix: 'WORK_UPLOAD:ADD_MEDIA',
  request: () =>
    apiCreateMedium(workId, data, {
      include: 'medium.image,medium.details'
    })
})

export const deleteWork = id => ({
  requestPrefix: 'WORK_UPLOAD:DELETE_WORK',
  request: () => apiDeleteWork(id)
})

export const rotateMedium = id => ({
  requestPrefix: 'WORK_UPLOAD:ROTATE_MEDIUM',
  params: { id },
  request: () =>
    apiRotateMedium(
      id,
      {
        degrees: -90
      },
      {
        include: 'medium.image,medium.details'
      }
    )
})

export const saveWork = (id, data) => ({
  requestPrefix: 'WORK_UPLOAD:SAVE',
  request: () => apiUpdateWork(id, data)
})

export const reorderMedia = (workId, ids) => ({
  requestPrefix: 'WORK_UPLOAD:REORDER_MEDIA',
  params: { ids },
  request: () =>
    apiReorderMedia(workId, {
      media_ids: ids
    }).catch(errorHandler)
})
